import aiChatbotImportPptxPdf from './ai-chatbot-import-pptx-pdf.module'

export default {
  aiChatbotImportPptxPdf,
}
